var __WEBPACK_NAMESPACE_OBJECT__ = sensorsDataAnalytic201505;